import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  Typography,
  createStyles,
  withStyles,
  WithStyles,
  Theme,
  Box,
  colors,
} from '@material-ui/core';
import { KeyboardArrowDown } from '@material-ui/icons';
import { Button } from 'app/components/Button';
import { useTranslation, Trans } from 'react-i18next';
import { Loader } from 'app/components/Loader';

const styles = (theme: Theme) => {
  return createStyles({
    container: {
      backgroundColor: theme.palette.primary.main,
      padding        : theme.spacing(4),
      display        : 'flex',
      flexDirection  : 'column',
      alignItems     : 'center',
      justifyContent : 'center',
      textAlign      : 'center',
      '& p': {
        color: colors.common.white,
        lineHeight: 1.25,
      },
    },
    heading: {
      fontSize    : '3rem',
      marginTop   : theme.spacing(1),
    },
    subheading: {
      color       : 'white',
      fontSize    : '2rem',
      marginBottom: theme.spacing(3),
    },
    bodyParagraph1: {
      fontSize    : '1.25rem',
      marginBottom: theme.spacing(1),
      maxWidth    : '500px',
      fontWeight  : 300,
    },
    bodyParagraph2: {
      fontSize    : '1.25rem',
      marginBottom: theme.spacing(1),
      maxWidth    : '500px',
    },
    highlight: {
      color     : '#00C9B7',
      fontWeight: 600,
    },
    arrowIcon: {
      color   : '#0e76a8',
      fontSize: '3rem',
      margin  : theme.spacing(2, 0),
    },
    clickText: {
      fontSize    : '0.875rem',
      marginBottom: theme.spacing(3),
    },
    continueButton: {
      color          : 'primary',
      padding        : theme.spacing(1.5, 6),
      fontSize       : '1rem',
      fontWeight     : 500,
      borderRadius   : '50px',
      textTransform  : 'none',
      '&:hover': {
        backgroundColor: '#F5F5F5',
      },
    },
  });
};

interface MappedProps {
  submitAction: any;
}

type Props = MappedProps & WithStyles<typeof styles>;

const ContactWelcomeLandingComponent = (props: Props) => {
  const { classes, submitAction } = props;
  const { t } = useTranslation();

  const [isLoading, setLoading] = useState<boolean>(false);
  
  const onClick = async () => {
    setLoading(true);
    try {
      await submitAction();
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Box className={classes.container}>

        <Typography className={classes.heading}>
          {t('contactWelcome.heading', { defaultValue: 'Great News!' })}
        </Typography>

        <Typography className={classes.subheading}>
          {t('contactWelcome.subheading', { defaultValue: "We've found options for you." })}        
        </Typography>

        <Typography className={classes.bodyParagraph1}>
          {t('contactWelcome.bodyParagraph1', { defaultValue: 'Continue to the final steps so we can provide your personalized results.' })}
        </Typography>

        <Typography className={classes.bodyParagraph2}>
          <Trans i18nKey="contactWelcome.bodyParagraph2">
            This service is <span className={classes.highlight}>100% FREE</span> and there is no obligation!
          </Trans>
        </Typography>

        <KeyboardArrowDown className={classes.arrowIcon} />

        <Typography className={classes.clickText}>
          {t('contactWelcome.clickText', { defaultValue: '(click below to continue)' })}
        </Typography>

        <Button
          variant   = 'contained'
          className = {classes.continueButton}
          onClick   = {onClick}
        >
          Continue
        </Button>
      </Box>
      { isLoading ? <Loader /> : null }
    </>
  );
};

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  submitAction: () => dispatch(ownProps.submitAction(ownProps.values)),
});

export const ContactWelcomeLanding = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(ContactWelcomeLandingComponent));